module.exports = __webpack_public_path__ + "img/point-agile-3.5b47270f.png";